// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610141236/js/" + chunkId + "." + {"44":"aaf86930","225":"79083f25","481":"d5340abf","486":"4e84d442","770":"523740bc"}[chunkId] + ".0.3468406324521559.chunk.js";
};